exports.getUniqueParam = () => {
  return Date.now().toString(36);
};